import { useCallback, useEffect, useRef } from 'react';

/** E2E-FIX1 (GAP-9) : rythme de lecture d'une tâche en cours ; sa fin est vue en moins de 2 s. */
export const TASK_POLL_MS = 1000;

/** Suit une tâche serveur (LONG-CMD) par sa seule ressource : `read` lit la tâche et rend vrai tant qu'elle est en cours.
 * Une seule boucle à la fois, aucune lecture du fil du dossier (PROBE-LIGHT) ; la boucle s'arrête au démontage. */
export function useTaskFollow(read: () => Promise<boolean>): { refresh: () => Promise<void> } {
  const readRef = useRef(read); readRef.current = read;
  const running = useRef(false);
  const alive = useRef(true);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const refresh = useCallback(async () => {
    if (running.current) return;
    running.current = true;
    try {
      while (alive.current && await readRef.current()) await new Promise(resolve => setTimeout(resolve, TASK_POLL_MS));
    } finally { running.current = false; }
  }, []);
  return { refresh };
}
